<template>
    <div class="registro">
        <v-form v-model="valid" ref="seguimiento">
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12 md10></v-flex>
                    <v-flex xs12 md4>
                        <v-flex xs12><h2>Jornada</h2></v-flex>
                        <v-flex xs12>
                            <v-combobox
                            v-model="evento"
                            :items="eventos"
                            item-value="id"
                            item-text="evento"
                            label="Selecciona el evento"
                            :rules="[v => !!v || 'La jornada es requerida']"
                            ></v-combobox>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 md8>
                        <v-flex xs12><h2>Persona</h2></v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                            v-model="persona"
                            :items="personas"
                            :loading="isLoading"
                            :search-input.sync="search"
                            item-text="completo"
                            item-value="id"
                            label="Persona"
                            placeholder="Busca a la persona"
                            return-object no-filter
                            autocomplete
                            :rules="[v => !!v || 'La persona es requerida']"
                            ></v-autocomplete>
                        </v-flex>
                    </v-flex>
                    
                    <v-flex xs12 v-show="persona != null">
                        <v-data-table
                            :headers="headers"
                            :items="registros"
                            class="elevation-1">
                            <template slot="items" slot-scope="props">
                                <!-- <td>{{ props.item.id }}</td> -->
                                <!-- <td>{{ props.item.nombre }}</td> -->
                                <!-- <td>{{ props.item.primer_apellido }}</td> -->
                                <!-- <td>{{ props.item.segundo_apellido }}</td> -->
                                <td>{{ props.item.servicio }}</td>
                                <td>{{ props.item.observaciones }}</td>
                                <td>{{ props.item.created_at }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                    
                    <v-flex xs12 md4>
                        <v-flex xs12><h2>Agregar Nuevo Servicio</h2></v-flex>
                        <v-flex xs12>
                            <v-combobox
                            v-model="servicio"
                            :items="servicios"
                            item-value="id"
                            item-text="servicio"
                            label="Selecciona el servicio"
                            :rules="[v => !!v || 'El servicio es requerido']"
                            ></v-combobox>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 md8>
                        <v-flex xs12><h2>Observación</h2></v-flex>
                        <v-flex xs12>
                            <v-textarea
                                name="input-7-1"
                                label="Observación"
                                v-model="observacion"
                                ></v-textarea>
                        </v-flex>
                    </v-flex>
                    <v-flex x12 md12>
                        <v-btn color="info" type="button" block @click.prevent="guardarRegistro">Guardar</v-btn>
                    </v-flex>
              </v-layout>
          </v-container>
        </v-form>
  </div>
</template>

<script>
import swal from "sweetalert2";
import axios from "axios";
import GlogalJS from '../mixins/GlobalJs';

export default {
  name: 'registro',
  components: {},
  mixins: [GlogalJS],
  data() {
    return {
      valid: false,
      eventos: [],
      evento: null,
      personas: [],
      persona: null,
      servicios: [],
      servicio: null,
      observacion: null,
      isLoading: false,
      search: null,
      headers: [//nombre de las columnas
        // { text: '# id', value: 'id' },
        // { text: 'Nombre', value: 'nombre' },
        // { text: 'Primer Apellido', value: 'primer_apellido' },
        // { text: 'Segundo Apellido', value: 'segundo_apellido' },
        { text: 'Servicio', value: 'servicio' },
        { text: 'Observacion', value: 'observacion' },
        { text: 'Registrado', value: 'created_at' }
      ],
      registros: [],
    }
  },
  mounted() {
    axios.get(`${this.server_api}/eventos?tipo=JORNADA`).then(response => { this.eventos = response.data; }).catch(error => { swal('Oops', 'No se pudieron cargar los eventos. ' + error, 'error')});
  },
  watch: {
    search (val) {
        if (val == null || val.length < 4) return
        if (this.isLoading) return
        this.isLoading = true
        fetch(`${this.server_api}/personas?search=${val}&evento=${this.evento.id}`)
            .then(res => res.json())
            .then(res => {
            this.personas = res
            })
            .catch(err => {
            //console.log(err)
            })
            .finally(() => (this.isLoading = false))
    },
    evento(val) {
        if (val == null) return;
        axios.get(`${this.server_api}/eventos/${this.evento.id}/servicios`).then(result => { this.servicios = result.data; }).catch(error => swal('Oops !', 'No pudimos cargar los servicios.' + error.response.data, 'error'));
    },
    persona(val) {
        this.obtenerDatos(val);
    }
  },
  methods: {
    guardarRegistro(){
        if (! this.$refs.seguimiento.validate()) {
            this.snackbar = true;
            return;
        }
        axios.post(`${this.server_api}/eventos/${this.evento.id}/persona/${this.persona.persona_id}/servicios`, {
            servicio_id: this.servicio.id,
            observacion: this.observacion
        }).then(response => { 
            swal('Great !', 'Registro guardado correctamente', 'success');
            this.obtenerDatos(this.persona);
            this.resetear();
        }).catch(error => { //console.log(error); 
            swal('Oops !', 'Algo salio mal.' + error.response.data, 'error')
        });
    },
    resetear() {
        // this.evento = null;
        // this.servicio = null;
        this.persona = null;
        this.observacion = null;
        this.$refs.segumiento.reset();
    },
    obtenerDatos(persona) {
        axios.get(`${this.server_api}/eventos/${this.evento.id}/persona/${persona.persona_id}/servicios`)
        .then(response => { this.registros = response.data; //console.log(response.data)
        }).catch(error => { swal('Oops!', 'No pudimos cargar los datos.' + error.response.data, 'error')
        });
    }
  }
}
</script>

<style scoped>
  .registro{
    width: 100%;
    height: 100%;
  }
</style>